import React from "react";
import SimilarPaymentProfiles from "./SimilarPaymentProfiles";
import withTabs from "../../../../components/withTabs";

export default withTabs(SimilarPaymentProfiles);
